import { ReceiveVideoCall } from "@/graphql/subscriptions.js";
import { API, graphqlOperation } from "aws-amplify";
// import { GetAllMessages } from "@/mixins/Chat/ListMessages.js";

export const RecieveVideoCallSub = {
  //   mixins: [GetAllMessages],
  data() {
    return {
      GetAllViolationsList: [],
      overlay: false,
      user_type: "",
      RecieveVideoCall: [],
    };
  },
  methods: {
    async subscribeToRecieveVideoCall() {
      await API.graphql(
        graphqlOperation(ReceiveVideoCall, {
          chat_id: this.$store.getters.get_chat_list.chat_id,
        })
      ).subscribe({
        next: async (data) => {
          this.RecieveVideoCall = data.value.data.ReceiveVideoCall;
          console.log("this.RecieveVideoCall", this.RecieveVideoCall);
          if (this.RecieveVideoCall.video_status == "INCOMING_CALL") {
            this.VideoCallDialog = true;
          }
        },
        error: (error) => {
          console.warn("Check the error", error);
        },
      });
    },
  },
};
